import { Batch, BatchStatus } from "@wingspanhq/wingspan-api-sdk";

import { selectorImportBatchRejectedRowsCount } from "./selectorImportBatchRejectedRowsCount";
import { selectorIsImportBatchUploadFinished } from "./selectorIsImportBatchUploadFinished";

type Args = {
  batch: Batch;
  /** `BatchSummary.progress.total` — undefined while the summary is loading. */
  itemCount?: number;
};

/** Line under the status pill, for the two states the pill alone understates. */
export const selectorImportBatchStatusSecondaryText = (
  args: Args
): string | undefined => {
  if (args.batch.status === BatchStatus.PENDING) {
    return "Import starting soon";
  }

  // The batch is still "Awaiting import", but some rows never made it into it.
  if (
    args.batch.status === BatchStatus.CREATED &&
    selectorImportBatchRejectedRowsCount(args.batch) > 0 &&
    selectorIsImportBatchUploadFinished({
      batch: args.batch,
      isEmptyBatch: args.itemCount === 0
    })
  ) {
    return "Partial upload";
  }

  return undefined;
};
